// Adjust these as per your requirement
const defaultTheresholdValue = 0; // 0.5;
const defaultOnce = true;

const vMotion = {
  mounted: (el, binding) => {
    const observer = new IntersectionObserver(
      (entries) => {
        const { isIntersecting } = entries[0];
        binding.value?.(isIntersecting, { el, entries, observer });
        if (isIntersecting && defaultOnce) observer.disconnect();
      },
      { threshold: defaultTheresholdValue }
    );

    observer.observe(el);
  },
};

export default vMotion;
